var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8FilterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,2c-0.60156,0 -1,0.39844 -1,1v3c0,0.30078 0.11328,0.48828 0.3125,0.6875l16,17c0.19922,0.19922 0.48828,0.3125 0.6875,0.3125h10c0.30078,0 0.48828,-0.11328 0.6875,-0.3125l16,-17c0.19922,-0.19922 0.3125,-0.38672 0.3125,-0.6875v-3c0,-0.60156 -0.39844,-1 -1,-1zM19,26v15c0,0.39844 0.19922,0.70703 0.5,0.90625l10,6c0.10156,0.10156 0.30078,0.09375 0.5,0.09375c0.19922,0 0.30078,0.00781 0.5,-0.09375c0.30078,-0.19922 0.5,-0.50781 0.5,-0.90625v-21z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FilterWhite);
export default __webpack_public_path__ + "static/media/icons8-filter-white.73a3b9549feeb369822b50201e977e03.svg";
export { ForwardRef as ReactComponent };